





















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import { getCmsColumnDetail } from "@/axios";

@Component({
  name: "articleDetailType1",
})
export default class extends Vue {
  @Prop()
  articleColumn: any;

  private page: any = 1;
  private page_size: any = 16;
  private listCount: any = 0;
  private articleList: any = [];

  @Watch("articleColumn", { immediate: true, deep: true })
  onarticleColumn(val: any, oldVal: any) {
    if (val) {
      // this.enterpriseMienData = val;
      this.listCount = val.articleCount;
      this.articleList = val.articleList;
      // console.log('articleColumn----------s-',val)
    }
  }

  private pageChange(page: any) {
    this.page = page;
    getCmsColumnDetail({
      id: (this as any).$route.query.id,
      page_size: this.page_size,
      page: this.page,
      landmarkId: (this as any).$route.query.landmarkId,
    }).then((res: any) => {
      // console.log('getCmsColumnDetail------------',res.data.data.articleList)
      this.articleList = res.data.data.articleList;
    });
  }

  private toDetail(item: any) {
    this.$router.push({
      name: "Article",
      query: {
        type: "1",
        landmarkId: item.landmark_id,
        id: item.id,
      },
    });
  }
}
